import { timeouts } from 'constants/values';

/**
  * Returns a dynamic timeout based on an array length
  * @param {number} length
  * @returns {number}
*/
export const getDynamicTimeoutForManualPrescriptionsZones = (length) => {
  // We use a dynamic timeout that depends on the number of zones.
  // If the dynamic timeout is major than the default timeout, we are going to use it.
  // If the dynamic timeout is minor then we going to use the default timeout.
  const dynamicTimeout = length * 1000;
  return dynamicTimeout > timeouts.MANUAL_PRESCRIPTION_ZONES
    ? dynamicTimeout
    : timeouts.MANUAL_PRESCRIPTION_ZONES;
};